import { Controller } from "@hotwired/stimulus"
import {
  ClassicEditor,
  Bold, Italic, Underline, Strikethrough,
  Essentials, Paragraph,
  List, Indent,
  FontColor, FontBackgroundColor,
  Link,
  Undo
} from "ckeditor5"

export default class extends Controller {
  static values = { toolbar: { type: String, default: "full" }, stamp: { type: String, default: "" } }

  connect() {
    ClassicEditor.create(this.element, {
      licenseKey: "GPL",
      plugins: [
        Essentials, Paragraph,
        Bold, Italic, Underline, Strikethrough,
        FontColor, FontBackgroundColor,
        Link,
        Undo
      ],
      toolbar: this.toolbarConfig()
    }).then(editor => {
      this.editor = editor
      this._applyHeight(editor)
      this.form = this.element.closest("form")
      if (this.form) {
        this.submitHandler = () => { this.element.value = editor.getData() }
        this.form.addEventListener("submit", this.submitHandler)
      }
      if (this.stampValue) {
        const domRoot = editor.editing.view.getDomRoot()
        let stampPosition = null

        domRoot.addEventListener("mousedown", () => {
          setTimeout(() => {
            const sel = editor.model.document.selection
            if (sel.isCollapsed) stampPosition = sel.getFirstPosition()
          }, 0)
        })

        domRoot.addEventListener("dblclick", () => {
          editor.model.change(writer => {
            const position = stampPosition || editor.model.document.selection.getFirstPosition()
            writer.setSelection(position)
            editor.model.insertContent(writer.createText(this.stampValue))
            stampPosition = null
          })
        })
      }
    }).catch(err => {
      console.error("[CKEditor] error:", err)
    })
  }

  disconnect() {
    if (this.form && this.submitHandler) {
      this.form.removeEventListener("submit", this.submitHandler)
    }
    this.editor?.destroy()
  }

  _applyHeight(editor) {
    const rows = parseInt(this.element.getAttribute("rows") || "0")
    if (!rows) return
    const height = `${rows * 22}px`
    editor.editing.view.change(writer => {
      const root = editor.editing.view.document.getRoot()
      writer.setStyle("min-height", height, root)
      writer.setStyle("max-height", height, root)
      writer.setStyle("overflow-y", "auto", root)
    })
  }

  toolbarConfig() {
    if (this.toolbarValue === "mini") {
      return [
        "bold", "italic", "underline", "|",
        "numberedList", "bulletedList", "indent", "outdent", "|",
        "fontColor", "fontBackgroundColor"
      ]
    }
    return [
      "bold", "italic", "underline", "strikethrough", "|",
      "numberedList", "bulletedList", "indent", "outdent", "|",
      "fontColor", "fontBackgroundColor", "|",
      "link", "|",
      "undo", "redo"
    ]
  }
}
